(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SupplierCouponDeleteController', SupplierCouponDeleteController);

    SupplierCouponDeleteController.$inject = ['$uibModalInstance', 'entity', 'SupplierCoupon'];

    function SupplierCouponDeleteController($uibModalInstance, entity, SupplierCoupon) {
        var vm = this;

        vm.supplierCoupon = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            SupplierCoupon.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
